import type { Locale } from './locales';
import { useLocale } from './useLocale';

/**
 * Cultural conventions of the UI: colours of growth / fall and win / loss, lucky-number presets, red envelopes.
 * Derived from the language only (zh → cn); there is no separate setting, so switching the language can never
 * change the economy — only how it looks.
 */
export type Culture = 'default' | 'cn';

export function cultureOf(locale: Locale): Culture {
  return locale === 'zh' ? 'cn' : 'default';
}

/** Sets <html data-culture>; tokens.css switches --up / --down / --win / --loss from it (like data-theme). */
export function applyCulture(locale: Locale, root: HTMLElement = document.documentElement): Culture {
  const c = cultureOf(locale);
  root.dataset.culture = c;
  return c;
}

/** Culture of the current URL language. */
export function useCulture(): Culture {
  return cultureOf(useLocale());
}
